"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bottomText = exports.saveButton = exports.link = exports.iframe = exports.heading = exports.checkbox = exports.adyenIframe = void 0;

var _react = require("@emotion/react");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: sticky;\n  bottom: 0;\n  flex-shrink: 0;\n  margin: 16px 0 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  vertical-align: baseline;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: -10px 0 -17px;\n  min-height: ", ";\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 0 8px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 32px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  p {\n    margin: 0 0 32px;\n  }\n\n  small {\n    display: block;\n    margin: 0 0 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var adyenIframe = (0, _react.css)(_templateObject());
exports.adyenIframe = adyenIframe;
var checkbox = (0, _react.css)(_templateObject2());
exports.checkbox = checkbox;
var heading = (0, _react.css)(_templateObject3());
exports.heading = heading;

var iframe = function iframe(paymentMethodType) {
  return function () {
    return (0, _react.css)(_templateObject4(), paymentMethodType === 'card' ? '345px' : '220px');
  };
};

exports.iframe = iframe;
var link = (0, _react.css)(_templateObject5());
exports.link = link;

var saveButton = function saveButton(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject6(), colors.white);
};

exports.saveButton = saveButton;
var bottomText = (0, _react.css)(_templateObject7());
exports.bottomText = bottomText;